export default "__VITE_ASSET__CeB3IByA__"